import React, { FC } from 'react';
import Lottie from 'react-lottie';
import SensoLoaderLottie from "../../images/lotties/senso-loader.json";
import { LOTTIE_DEFAULT_OPTIONS } from '../../constants/lottie';

export interface SensoLoaderI {
    size?: number;
}

const SensoLoader: FC<SensoLoaderI> = ({ size = 170 }) => {
    return (
        <Lottie options={{
            ...LOTTIE_DEFAULT_OPTIONS,
            animationData: SensoLoaderLottie,
        }} height={size} width={size} />
    );
};

export default SensoLoader;
